/**
 * Différé du bouton de paiement accéléré (Shop Pay / dynamic checkout).
 *
 * Le bouton lui-même est rendu par Shopify dans une balise <template>,
 * donc invisible et inerte au chargement : le navigateur ne télécharge/
 * n'exécute PAS le SDK checkout tant qu'on n'a pas cloné le contenu du
 * template dans le DOM.
 *
 * On déclenche cette activation dès le premier signe d'engagement du
 * visiteur (scroll, mouvement de souris, touch, clavier) — ou, filet de
 * sécurité, après 3s même sans interaction, pour ne pas pénaliser un
 * visiteur qui reste immobile en lisant la fiche produit.
 */
(function () {
  function activate(container) {
    var tpl = container.querySelector('template');
    if (!tpl) return;
    var fragment = tpl.content.cloneNode(true);
    container.replaceWith(fragment);
  }

  function init() {
    var containers = document.querySelectorAll('[data-dynamic-checkout-lazy]');
    if (!containers.length) return;

    var activated = false;
    var events = ['scroll', 'mousemove', 'touchstart', 'keydown', 'pointerdown'];
    var fallbackTimer;

    function activateAll() {
      if (activated) return;
      activated = true;
      containers.forEach(activate);
      events.forEach(function (evt) {
        window.removeEventListener(evt, activateAll);
      });
      clearTimeout(fallbackTimer);
    }

    events.forEach(function (evt) {
      window.addEventListener(evt, activateAll, { once: true, passive: true });
    });

    fallbackTimer = setTimeout(activateAll, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
